const getters = {
  //user: state => state.app.user,
  userGroup: state => state.app.userGroup,
  empresa: state => state.app.empresa,
  empresas: state => state.app.empresas,
  suscripcion: state => state.app.suscripcion,
  drawer: state => state.app.drawer,
  language: state => state.app.language,
  busy: state => state.app.busy,
  busyText: state => state.app.busyText,
  misCpcs: state => state.app.misCpcs,

  //DASHBOARD
  dashboardDrawer: state => state.dashboard.dashboardDrawer,
  addOrEditFilterDialogVisible: state =>
    state.dashboard.addOrEditFilterDialogVisible,
  seletFilterDialogVisible: state => state.dashboard.seletFilterDialogVisible,
  saveQueryDialogVisible: state => state.dashboard.saveQueryDialogVisible,
  filters: state => state.dashboard.filters,
  queries: state => state.dashboard.queries,
  pacs: state => state.dashboard.pacs2, // rEVISAR SI ESTO VA O NO

  errorLogs: state => state.errorLog.logs,

  //procesos
  procesos: state => state.procesos.items
  //TIPS
  //tipsMisCpcs: state => state.tips.tipsMisCpcs,
  //tipsComponentes: state => state.tips.Componentes,
};

export default getters;
